import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../../components/layout/ToastStyles";
import {Apis} from "../../../util/data";
import PageContainer from "../../../components/layout/PageContainer";
import PageSection from "../../../components/layout/PageSection";
import {PageBackLabel} from "../../../components/layout/PageBackLabel";
import PageTitle from "../../../components/layout/PageTitle";
import ProductoRiskForm from "./ProductoRiskForm";

const ProductoRiskNew = () => {

  const navigate = useNavigate()

  const {id} = useParams()

  const onCreate = (data) => {
    axios.post(Apis.PROD + '/riesgo/' + id + '/productos/' + data.id)
      .then(res => {
        successToast("Producto del Riesgo creado correctamente")
        navigate('/riesgos/' + id + '/productos')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Productos del Riesgo' onClick={() => navigate('/riesgos/' + id + '/productos')}/>
        <PageTitle title={'Producto del Riesgo'}/>
      </PageSection>

      <PageSection>
          <ProductoRiskForm value={{}} onSubmit={(prod) => onCreate(prod)}/>
      </PageSection>
    </PageContainer>
  )
}

export default ProductoRiskNew;
